module.exports = __webpack_public_path__ + "assets/img/hill-6.d03ac1af.png";